export default __webpack_public_path__ + "static/media/bar-chart.09913d18.svg";